import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { silenceErrorAlert } from 'conversations-error-reporting/error-actions/builders/silenceErrorAlert';
import { FETCH_CHATFLOW } from '../constants/asyncActionTypes';
import { getChatflow } from '../clients/getChatflow';
export const fetchChatflow = createAsyncAction({
  requestFn: getChatflow,
  actionTypes: FETCH_CHATFLOW,
  toRecordFn: chatflowResponse => chatflowResponse,
  failureMetaActionCreator: silenceErrorAlert
});